import { LG_USER_INFO } from "@logex/framework/lg-application";
import { ApplicationPermissions } from "../app-permissions";
import { inject } from "@angular/core";
import { AppUser } from "@shared/app-user";

export { ApplicationPermissions, LG_USER_INFO };

export abstract class AuthorizationBase {
    protected _userInfo = inject(LG_USER_INFO) as AppUser;

    constructor() {
        this.admin = this._userInfo.hasPermission(ApplicationPermissions.ADMIN);
        this.internal = this._userInfo.hasPermission(ApplicationPermissions.INTERNAL);
        this.viewAllSpecialisms = this._userInfo.hasPermission(
            ApplicationPermissions.VIEW_ALL_SPECIALISMS
        );
        this.viewAllDiagnosisGroups = this._userInfo.hasPermission(
            ApplicationPermissions.VIEW_ALL_DIAGNOSIS_GROUPS
        );
        this.exclusionRules = this._userInfo.hasPermission(ApplicationPermissions.EXCLUSION_RULES);
    }

    abstract readonly access: boolean;

    readonly admin: boolean;
    readonly internal: boolean;

    readonly viewAllSpecialisms: boolean;
    readonly viewAllDiagnosisGroups: boolean;

    readonly exclusionRules: boolean;

    canViewSpecialism(specialismCode?: number): boolean {
        if (this.viewAllSpecialisms) return true;
        return specialismCode != null && this._userInfo.viewSpecialisms.has(specialismCode);
    }

    canViewDiagnosisGroup(diagnosisGroupCode?: number): boolean {
        if (this.viewAllDiagnosisGroups) return true;
        return (
            diagnosisGroupCode != null && this._userInfo.viewDiagnosisGroups.has(diagnosisGroupCode)
        );
    }

    get viewableSpecialisms(): number[] {
        return Array.from(this._userInfo.viewSpecialisms.keys());
    }

    get viewableDiagnosisGroups(): number[] {
        return Array.from(this._userInfo.viewDiagnosisGroups.keys());
    }
}
